export enum IdMomentoProcesso {
    Sentenca = 18,
}
